export default __webpack_public_path__ + "static/media/mat.d9653e41.jpg";